import { instance } from './ApiRequest';
import {
    LOGIN, REGISTER, SESSION_TOKEN, USER_NAME, PROFILE_URL, ROOT_PATH,
    GET_CHANGE_PASSWORD, FORGOT_PASSWORD, RESET_PASSWORD, SET_PASSWORD, Last_LOGIN_DATETIME,
    USER_ROLE, USER_COMPANY, LOGOUT, APP_USER_ID, ADMIN_LOGIN, GET_PORTAL_CONFIG, GET_PORTAL_CONFIG_BY_KEY, LOGIN_TIME, BANK_ADMIN_LOGIN,
    FORGOT_STUDENT_PASSWORD, WHITELISTED_IP_ADDRESS, UPDATESTUDENTDATEOFBIRTH, FORGET_PASSWORD_SEND_OTP, HELP_DESK_ADMIN_LOGIN,
    BIOMETRIC_ADMIN_LOGIN
} from 'constants/constants';
import moment from 'moment';
import _utils from './Utils';
import axios from "axios"; 

import { GENERATE_AADHAAR_OTP , SUBMIT_AADHAAR_OTP }  from "../constants/constants";
import { SUBMIT_CONSENT, GET_CURRENT_CONSENT_VERSION } from "../constants/constants";
import { GENERATE_MOBILE_OTP, VERIFY_MOBILE_OTP, GENERATE_EMAIL_OTP, VERIFY_EMAIL_OTP } from "../constants/constants";

let _authService = {
    isAuthenticated() {
        // Sprint 2.1: a stale session belonging to any other portal role must be cleared here (not
        // just "Admin"), and this guard must itself confirm the role is "User" before reporting the
        // session as an authenticated student session — previously any non-"Admin" role's leftover
        // SESSION_TOKEN (e.g. a stale BankAdmin/HelpDeskAdmin/BiometricAdmin session) was treated as
        // a valid student session because the role was never checked in the return value.
        if (localStorage[USER_ROLE] && localStorage[USER_ROLE] !== "User") {
            localStorage.clear();
        }
        return (localStorage[SESSION_TOKEN] !== undefined && localStorage[USER_ROLE] == "User");
    },

    async cachePortalConfiguration() {
        try {
            var result = await instance.get(GET_PORTAL_CONFIG + "?portalConfigurationId=1");
            localStorage['Portal_Logo'] = result.data.Portal_Logo;
            localStorage['Copyright_Text'] = result.data.Copyright_Text;
            localStorage['Exam_Name'] = result.data.Exam_Name;
            localStorage['Subtitle'] = result.data.Subtitle;

            localStorage['Exam_note'] = result.data.Exam_note;
            localStorage['ChallanPageNote'] = result.data.ChallanPageNote;
            localStorage['ChallanPaymentFormSubmitNote'] = result.data.ChallanPaymentFormSubmitNote;
            localStorage['OnlinePaymentFormSubmitNote'] = result.data.OnlinePaymentFormSubmitNote;


            return result;
        } catch { }
    },

    async getClientIP() {
        try {
            try {
                if (WHITELISTED_IP_ADDRESS == "*") {
                    return true;
                }

                let result = false;

                result = axios
                    .get(`https://api.ipify.org?format=json`)
                    .then((response) => {
                        if (response && response.status == 200) {
                            const data = response.data;

                            if (data.ip && String(WHITELISTED_IP_ADDRESS).includes(data.ip)) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        }
                        else {
                            return false;
                        }

                    });

                return result;
            } catch (e) {
                return false;
            }
        } catch { return false; }
    },

    async getPortalConfigurationByKey(key) {
        try {
            if (!localStorage[key]) {
                var result = await instance.get(GET_PORTAL_CONFIG_BY_KEY + "?key=" + key);

                if (result.status == 200 && result.data) {
                    localStorage[key] = result.data.Value;
                }
                else {
                    localStorage[key] = "";
                }
            }
            else {
                result = { status: 200, data: { Key: key, Value: localStorage[key] } }
            }
            return result;
        } catch { }
    },

    isAdminAuthenticated() {
        // Sprint 2.1: clear on ANY mismatched role, not just "User" — previously a stale
        // BankAdmin/HelpDeskAdmin/BiometricAdmin session was never cleared here.
        if (localStorage[USER_ROLE] && localStorage[USER_ROLE] !== "Admin") {
            localStorage.clear();
        }
        return (localStorage[SESSION_TOKEN] !== undefined && localStorage[USER_ROLE] == "Admin");
    },

    isBankAdminAuthenticated() {
        if (localStorage[USER_ROLE] && localStorage[USER_ROLE] !== "BankAdmin") {
            localStorage.clear();
        }
        return (localStorage[SESSION_TOKEN] !== undefined && localStorage[USER_ROLE] == "BankAdmin");
    },

    isHelpDeskAdminAuthenticated() {
        if (localStorage[USER_ROLE] && localStorage[USER_ROLE] !== "HelpDeskAdmin") {
            localStorage.clear();
        }
        return (localStorage[SESSION_TOKEN] !== undefined && localStorage[USER_ROLE] == "HelpDeskAdmin");
    },

    isBiometricAdminAuthenticated() {
        if (localStorage[USER_ROLE] && localStorage[USER_ROLE] !== "BiometricAdmin") {
            localStorage.clear();
        }
        return (localStorage[SESSION_TOKEN] !== undefined && localStorage[USER_ROLE] == "BiometricAdmin");
    },

    async login(body) {
        return await instance.post(LOGIN, body);
    },

    async adminLogin(body) {
        return await instance.post(ADMIN_LOGIN, body);
    },

    async bankAdminLogin(body) {
        return await instance.post(BANK_ADMIN_LOGIN, body);
    },

    async helpDeskAdminLogin(body) {
        return await instance.post(HELP_DESK_ADMIN_LOGIN, body);
    },

    async biometricAdminLogin(body) {
        return await instance.post(BIOMETRIC_ADMIN_LOGIN, body);
    },

    async register(body) {
        return await instance.post(REGISTER, body);
    },

    setSessionData(userData) {
        localStorage[APP_USER_ID] = userData.Application_Id;
        localStorage[SESSION_TOKEN] = userData.AuthToken;
        localStorage[USER_ROLE] = "User";
        localStorage[USER_COMPANY] = "Online User Registration";
        localStorage[USER_NAME] = userData.First_Name + " " + (userData.Last_Name ? userData.Last_Name : '');
        // Security hardening: the backend now returns a ready-to-use base64 data URI for
        // Profile_Pic_Path (candidate identity containers are private, no public blob URL to build).
        localStorage[PROFILE_URL] = userData.Profile_Pic_Path ? userData.Profile_Pic_Path : "";
        localStorage[Last_LOGIN_DATETIME] = moment();
        localStorage["SID"] = userData.Id;

        localStorage[LOGIN_TIME] = moment();
    },

    setAdminSessionData(userData) {
        localStorage[SESSION_TOKEN] = userData.AuthToken;
        localStorage[USER_ROLE] = "Admin";
        localStorage[USER_COMPANY] = "Online User Registration";
        localStorage[USER_NAME] = userData.FirstName + " " + (userData.LastName ? userData.LastName : '');
        localStorage[LOGIN_TIME] = moment();
    },

    setBankAdminSessionData(userData) {
        localStorage[SESSION_TOKEN] = userData.AuthToken;
        localStorage[USER_ROLE] = "BankAdmin";
        localStorage[USER_COMPANY] = "Online User Registration";
        localStorage[USER_NAME] = userData.FirstName + " " + (userData.LastName ? userData.LastName : '');
        localStorage[LOGIN_TIME] = moment();
    },

    setHelpDeskAdminSessionData(userData) {
        localStorage[SESSION_TOKEN] = userData.AuthToken;
        localStorage[USER_ROLE] = "HelpDeskAdmin";
        localStorage[USER_COMPANY] = "Online User Registration";
        localStorage[USER_NAME] = userData.FirstName + " " + (userData.LastName ? userData.LastName : '');
        localStorage[LOGIN_TIME] = moment();
    },

    setBiometricAdminSessionData(userData) {
        localStorage[SESSION_TOKEN] = userData.AuthToken;
        localStorage[USER_ROLE] = "BiometricAdmin";
        localStorage[USER_COMPANY] = "Online User Registration";
        localStorage[USER_NAME] = userData.FirstName + " " + (userData.LastName ? userData.LastName : '');
        localStorage[LOGIN_TIME] = moment();
    },

    async logout() {
        console.log("Logout session");
        //await instance.get(LOGOUT);
        if (localStorage[USER_ROLE] == "Admin") {
            localStorage.clear();
            window.location.href = '/admin/login';
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
    },

    async logoutBankAdmin() {
        console.log("Logout session");
        //await instance.get(LOGOUT);
        if (localStorage[USER_ROLE] == "BankAdmin") {
            localStorage.clear();
            window.location.href = '/bankadmin/login';
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
    },

    async logoutHelpDeskAdmin() {
        console.log("Logout session");
        //await instance.get(LOGOUT);
        if (localStorage[USER_ROLE] == "HelpDeskAdmin") {
            localStorage.clear();
            window.location.href = '/helpDeskAdmin/login';
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
    },

    async logoutBiometricAdmin() {
        console.log("Logout session");
        //await instance.get(LOGOUT);
        if (localStorage[USER_ROLE] == "BiometricAdmin") {
            localStorage.clear();
            window.location.href = '/biometricadmin/login';
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
    },

    async clearSessionHist() {
        console.log("Clearing session data");
        //await instance.get(LOGOUT);
        localStorage.clear();
    },

    async changePassword(params) {
        return await instance.post(GET_CHANGE_PASSWORD, params);
    },
    async forgotPassword(email) {
        return await instance.get(FORGOT_PASSWORD + "?email=" + email);
    },
    async resetPassword(params, token) {
        return await instance.post(RESET_PASSWORD + "?token=" + token, params);
    },
    async setPassword(params, token) {
        return await instance.post(SET_PASSWORD + "?token=" + token, params);
    },
    async ForgotStudentPassword(params) {
        return await instance.post(FORGOT_STUDENT_PASSWORD, params);
    },
    async UPDATESTUDENTDATEOFBIRTH(body) {
        return await instance.post(UPDATESTUDENTDATEOFBIRTH, body);
    },
    async ForgetPasswordSendOTP(body) {
        return await instance.post(FORGET_PASSWORD_SEND_OTP, body);
    },
    // async GenerateAadhaarOTP(body, token) {
    //     return await instance.post(GENERATE_AADHAAR_OTP + "?token=" + token, body);
    // }
    
    async GenerateAadhaarOTP(body, token) {
        return await instance.post(GENERATE_AADHAAR_OTP, body, {
            headers: {
                Authorization: `Bearer ${token}`,  // Pass token in the Authorization header
                "Content-Type": "application/json" // Ensure the body is sent as JSON
            },
            validateStatus: function (status) {
                // Accept all HTTP status codes so the response is always returned
                return true;
            }
        });
    },

    async SubmitAadhaarOTP(body, token) {
        return await instance.post(SUBMIT_AADHAAR_OTP, body, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            validateStatus: function (status) {
                // Accept all HTTP status codes so the response is always returned
                return true;
            }
        });
    },

    // Sprint 2.6.1 (Enterprise Identity Modernization): Mobile OTP + Email OTP, the active identity
    // verification mechanism. Plain anonymous POSTs, matching ForgetPasswordSendOTP's style — no
    // vestigial client-side Bearer token like the legacy Aadhaar calls above.
    async GenerateMobileOTP(body) {
        return await instance.post(GENERATE_MOBILE_OTP, body);
    },
    async VerifyMobileOTP(body) {
        return await instance.post(VERIFY_MOBILE_OTP, body);
    },
    async GenerateEmailOTP(body) {
        return await instance.post(GENERATE_EMAIL_OTP, body);
    },
    async VerifyEmailOTP(body) {
        return await instance.post(VERIFY_EMAIL_OTP, body);
    },

    // Sprint 2.2 (Privacy & Consent Foundation)
    async getCurrentConsentVersion() {
        return await instance.get(GET_CURRENT_CONSENT_VERSION);
    },
    async submitConsent(body) {
        return await instance.post(SUBMIT_CONSENT, body);
    }

}

export default _authService;